import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SettingsService } from '../settings/settings.service';

declare const Appcues: {
    show(id: string): void;
};

@Injectable({ providedIn: 'root' })
export class AppcuesService {

    constructor(
        private settingsService: SettingsService,
        private activatedRoute: ActivatedRoute,
    ) {}

    /**
     * Exibe um flow appcues usando seu alias em settings.
     *
     * @param alias
     */
    public showFlowByAlias(alias: string) {
        try {
            const flowId = this.getFlowIdByAlias(alias);
            if (!flowId) throw new Error('Id do flow não contrado no environment!');
            Appcues.show(flowId);
        } catch ({ message }) {
            // tslint:disable-next-line: no-console
            console.error('Falha ao exibir flow appacues por alias:', message);
        }
    }

    /**
     * Exibe um flow ppacues usando seu ID previamente conhecido
     *
     * @param id
     */
    public showFlowById(id: string) {
        try {
            Appcues.show(id);
        } catch ({ message }) {
            // tslint:disable-next-line: no-console
            console.error('Falha ao exibir flow appacues por ID:', message);
        }
    }

    /**
     * Observa e exibe flows do Appcues com base em alias quando uma URL é carregada, através do queryParam "openFlow"
     * - Ex: /path/?openFlow=flow-alias-1&openFlow=flow-alias-2
     *
     * @param allowedKeys - Lista de aliases de appcues eprmitidas para observação (opcional)
     */
    public listenAndShowFlowsByURL(allowedKeys?: string[]) {
        window.addEventListener('load', () => this.activatedRoute.queryParams
        .pipe(filter((params) => !!params.openFlow))
        .subscribe(({ openFlow }) => []
            .concat(openFlow)
            .filter((alias) => allowedKeys ? allowedKeys.includes(alias) : true)
            .forEach((alias) => this.showFlowByAlias(alias)),
        ));
    }

    /**
     * Busca o ID de um flow com base em seu alias no arquivo de configurações
     *
     * @param alias
     */
    private getFlowIdByAlias(alias: string) {
        const appcues = this.settingsService.getConfigurationKeyValue('appcues');
        if (appcues && appcues.flowIdsByAlias) {
            return appcues.flowIdsByAlias[alias] as string;
        } else {
            // tslint:disable-next-line: no-console max-line-length
            console.warn('Não foi possível carregar os aliases de appcues do environment (appcues.flowIdsByAlias), você configurou corretamente?');
            return null;
        }
    }

}
